// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"spinner_Spinner__1fp0O","brand":"spinner_brand__14mPd"};